var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass: "col-12",
        class: _vm.continueWithoutMobile ? "col-md-9 col-lg-6" : "col-md-6",
      },
      [
        _c("div", { staticClass: "row block-border mx-0" }, [
          _c(
            "div",
            {
              staticClass: "col-12 px-0 bg-white",
              class: _vm.continueWithoutMobile ? "col-md-6" : "",
            },
            [
              _c(
                "div",
                [
                  _c("ob1-tag", {
                    attrs: { label: _vm.title, type: "subscribed" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mx-1 ms-md-2 me-md-1" },
                [
                  _c("p", { staticClass: "mb-0" }, [
                    _c("span", { staticClass: "text-mw" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.offerLabel))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.modifyOffer
                    ? _c("ob1-liens", {
                        staticClass: "pt-0 d-webview-none",
                        attrs: {
                          text: _vm.modifyOffer.label,
                          href: _vm.modifyOffer.url,
                          "with-arrow": true,
                          "data-oevent-category": "votre_selection_offre",
                          "data-oevent-action": "modifier_mon_choix",
                          "data-oevent-label": _vm.modifyOffer.url,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.continueWithoutMobile
            ? _c(
                "div",
                {
                  staticClass:
                    "col-12 col-md-6 px-0 bg-gray2 d-webview-none d-flex align-items-center",
                },
                [
                  _c("div", { staticClass: "position-relative" }, [
                    _c("div", { staticClass: "arrow-bottom d-md-none" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "20px",
                            height: "20px",
                            viewBox: "0 0 20 20",
                          },
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                stroke: "none",
                                "stroke-width": "1",
                                fill: "none",
                                "fill-rule": "evenodd",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    transform:
                                      "translate(-150.000000, -262.000000)",
                                    fill: "#000000",
                                  },
                                },
                                [
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        transform:
                                          "translate(15.000000, 153.000000)",
                                      },
                                    },
                                    [
                                      _c("polygon", {
                                        attrs: {
                                          transform:
                                            "translate(145.000000, 119.000000) rotate(180.000000) translate(-145.000000, -119.000000) ",
                                          points: "145 109 155 129 135 129",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "arrow-right d-none d-md-block" },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "20px",
                              height: "20px",
                              viewBox: "0 0 20 20",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  stroke: "none",
                                  "stroke-width": "1",
                                  fill: "none",
                                  "fill-rule": "evenodd",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      transform:
                                        "translate(-274.000000, -294.000000)",
                                      fill: "#000000",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          transform:
                                            "translate(27.000000, 248.000000)",
                                        },
                                      },
                                      [
                                        _c("polygon", {
                                          attrs: {
                                            transform:
                                              "translate(257.000000, 56.000000) rotate(90.000000) translate(-257.000000, -56.000000) ",
                                            points: "257 46 267 66 247 66",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ms-1 ms-md-3 me-1 pt-2 pt-md-0 pb-0" },
                      [
                        _c("div", [_vm._v(_vm._s(_vm.modifyMobileLabel))]),
                        _vm._v(" "),
                        _c("ob1-liens", {
                          staticClass: "pt-0 py-md-0",
                          attrs: {
                            text: _vm.continueWithoutMobile.label,
                            href: _vm.continueWithoutMobile.url,
                            "with-arrow": true,
                            "data-oevent-category": "votre_selection_offre",
                            "data-oevent-action": "continuer_sans_mobile",
                            "data-oevent-label": _vm.continueWithoutMobile.url,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }